<!-- eslint-disable max-len -->
<template>
  <div id="app">
    <header class="site-header">

      <div class="wrapper">


        <router-link class="site-title" to="/">CC</router-link> <span style="font-size:small;font-style:italic;">- tools</span>

      </div>

    </header>

    <div class="wrapper">
      <transition name="status">
        <div class="my-2 p-2 rounded-lg secondary-back" v-if="statusMsg">
          {{statusMsg}}
          <button class="opacity-75 cursor-pointer px-3 float-right hover:opacity-100" @click="statusMsg=null;">
            ×
          </button>
        </div>
      </transition>
    </div>
    <router-view ref="routerView"/>

    <footer class="site-footer">

      <div class="wrapper">
        <h2 class="footer-heading mt-4 mb-2 text-base">Implicit: content-enabled learning communities</h2>
        <hr>

      </div>

    </footer>

  </div>
</template>

<!-- eslint-disable -->
<style scoped>
/* already in tailwind.css - not sure why it is needed here as well */
/* needs to be applied to the :after psuedo-element */
.clearfixInAfter {
  content: "";
  display: table;
  clear: both;
}

.secondary-back {
  background-color: #C9D99E;
}
.status-enter-active,
.status-leave-active {
  transition: opacity 0.5s;
}
.status-enter,
.status-leave-to {
  opacity: 0;
}

/* nav specific */
.site-header {
  @apply bg-primaryColor text-white;

  border-bottom: 1px solid #e8e8e8;
  min-height: 56px;
  padding: 10px 0px;

  /* Positioning context for the mobile navigation icon */
  position: relative;
}

.site-header a, .site-header a.site-title {
  @apply text-white;
}

.site-title {
  /* TODO: TailWind implement below line */
  /* font-family: "MetropolisRegular", $base-font-family; */
  font-size: 26px;
  line-height: 56px;
  letter-spacing: -1px;
  margin-bottom: 0;
}
/* should the below be removed? */
.site-title, .site-title:visited {
  color: #424242;
}

.site-nav .page-link {
  /* color: $text-color; */
  /* color: white; */
  /* color: $brand-color; */
  line-height: 1.45;
}

/** ==================== */
/** implement site menus */
/** ==================== */
/** common bits */
.site-nav {
  float: right;
  line-height: 56px;
  @apply p-2;
}
/** mobile-only version (menu) */
@media screen and (max-width: theme('screens.sm')) {
  .site-nav {
    position: absolute;
    top: 16px;
    right: 30px;
    background-color: theme('colors.backgroundColor');
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    text-align: right;
  }
  .site-nav .menu-icon {
    display: block;
    float: right;
    /* width: 36px;   */
    /* height: 26px; */
    /* line-height: 0; */
    /* padding-top: 10px; */
    text-align: center;
  }
  .site-nav .menu-icon > svg {
    width: 18px;
    height: 15px;
  }
  .site-nav .menu-icon > svg path {
    /* fill: $grey-color-dark; */
    fill: #424242;
  }

  .site-nav .trigger {
    clear: both;
    display: none;
  }

  .site-nav:hover .trigger {
    display: block;
    padding-bottom: 5px;
  }

  .site-nav .page-link {
    display: block;
    padding: 5px 10px;
    color: theme('colors.textColor');
  }
}

/** 'desktop' version */
@screen sm {
  .site-nav .menu-icon {
    display: none;
  }

  /* Gaps between nav items, but not on the first one */
  .site-nav .page-link:not(:first-child) {
    margin-left: 20px;
  }
}


/**
 * Site footer
 */
.site-footer {
    border-top: 1px solid #e8e8e8;
    @apply py-2 px-0;
}

.contact-list,
.social-media-list {
    list-style: none;
    margin-left: 0;
}

.footer-col-wrapper {
    font-size: 15px;
    color: #828282;
    /* @apply -ml-4; */
}

.footer-col-wrapper:after {
    @apply clearfixInAfter;
}

.footer-col {
    float: left;
    @apply mb-4 pl-0;
}
@screen sm {
  .footer-col {
    float: none;
    @apply w-full;
  }
}
</style>

<!-- eslint-disable -->
<script>
var clicky_site_ids = clicky_site_ids || [];
clicky_site_ids.push(101061215);
(function() {
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = '//static.getclicky.com/js';
  ( document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0] ).appendChild( s );
})();
</script>

<script>
import utils from '@/services/utils';
import userInfo from '@/services/userInfo';

export default {
  name: 'app',
  data() {
    return {
      statusMsg: null,
      signedIn: false,
      chSubscriptions: [],
      userId: null,
      acctUsername: null,
    };
  },
  methods: {
    _ensureNavToPath: function(path) {
      if (this.$router.currentRoute.path != path) this.$router.push(path);
    },
    updateAuth: function(authRes) {
      this.setSignedIn({authRes, newUser:false});
    },
    setSignedOut: function() {
      this.signedIn = false;
      this.chSubscriptions = [];
      this.userId = null;
      this.userFName = null;
    }
  },
  mounted() {
    let timer = -1;
    this.$root.$on('status-message', (msg) => {
      clearTimeout(timer);
      this.statusMsg = msg;
      timer = setTimeout(() => {
        this.statusMsg = null;
      }, 5 * 1000);

    });
  }
};
</script>
